'use client';
import ScrollView from "./ScrollView.js";
export default ScrollView;